import { ValidationException } from './validationException.js';
/**
 * Shared per-org uniqueness for a numeric `code` field.
 *
 * Uses a filtered `query` (equality on `code`, small limit) — never `list(orgId)`.
 * `entityLabel` is the noun phrase after "Já existe" (e.g. "um produto",
 * "uma ordem de produção").
 */
export async function assertCodeUniquePerOrg(crud, orgId, code, currentId, opts) {
    const matches = await crud.query(orgId, {
        filters: [{ field: 'code', operator: '==', value: code }],
        limit: 2,
    });
    // Re-check code in memory: defense if a data source ignores/loosens `filters`.
    const conflict = matches.find((row) => Number(row.code) === code && row.id !== currentId);
    if (conflict) {
        throw new ValidationException(`Já existe ${opts.entityLabel} com o código informado.`, {
            code,
            conflictId: conflict.id,
        });
    }
}
//# sourceMappingURL=assertCodeUniquePerOrg.js.map